import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { VendorService } from "../../_services/vendor.service";
import { FlashMessagesService } from "angular2-flash-messages";

export interface VendorDialogData {
  vendor: any;
}

@Component({
  selector: 'app-vendor-form',
  templateUrl: './vendor-form.component.html',
  styleUrls: ['./vendor-form.component.css']
})
export class VendorFormComponent implements OnInit {

  public vendorForm: FormGroup;
  public loading = false;
  public isEditMode = false;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<VendorFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VendorDialogData,
    private vendorService: VendorService,
    private flashMessages: FlashMessagesService
  ) {
    // Initialize form
    this.vendorForm = this.formBuilder.group({
      name: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      phone: [null],
      account_no: [null],
      company_name: [null],
      company_email: [null],
      company_phone: [null]
    });

    // If edit mode, prefill values
    if (data.vendor) {
      this.isEditMode = true;
      this.vendorForm.patchValue(data.vendor);
    }
  }

  ngOnInit() {}

  // Field validation utility
  isFieldValid(field: string) {
    const control = this.vendorForm.get(field);
    return (
      control &&
      !control.valid &&
      control.touched &&
      !(control.errors && control.errors.min)
    );
  }

  // Save vendor (create or update)
  saveVendor() {
    if (this.vendorForm.valid) {
      const formData = this.vendorForm.value;
      this.loading = true;

      const request$ = this.isEditMode
        ? this.vendorService.update({ ...formData, vendor_id: this.data.vendor.vendor_id })
        : this.vendorService.create(formData);

      request$.subscribe(
        (response: any) => {
          this.flashMessages.show(response.message, {
            cssClass: "alert-success",
            timeout: 4000
          });
          
          this.loading = false;
          setTimeout(function () {
            this.dialogRef.close(response);
          }.bind(this), 3000);

          window.scrollTo(0, 0);
        },
        (err: any) => {
          this.flashMessages.show(err.error.message, {
            cssClass: "alert-warning",
            timeout: 5000
          });
          this.loading = false;
        }
      );
    } else {
      this.validateAllFormFields(this.vendorForm);
    }
  }

  // Mark all form fields as touched
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  // Close dialog without action
  onNoClick(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/vendor-form/vendor-form.component.ts